// extracted by mini-css-extract-plugin
export default {"connectionStatusIcon":"Table_connectionStatusIcon__nja0T","connectionStatusCell":"Table_connectionStatusCell__cQqZn"};